import { Stack } from "@mui/joy";
import { Outlet } from "@tanstack/react-router";

import { useLeagueEntriesQuery, useLeagueQuery } from "@/hooks/competitions";

import { LeagueEntriesTableContextProvider } from "./LeagueEntriesContext";
import LeagueEntriesTable from "./LeagueEntriesTable";
import LeagueEntriesToolbar from "./LeagueEntriesToolbar";
import MergeSourceUserBanner from "./MergeSourceUserBanner";

const emptyArray: never[] = [];

export default function LeagueEntries({ leagueUuid }: { leagueUuid: string }) {
  const entriesQuery = useLeagueEntriesQuery(leagueUuid);

  const entries = entriesQuery.data || emptyArray;

  const { data: league } = useLeagueQuery(leagueUuid);

  return (
    <Stack sx={{ flex: 1, minWidth: 0 }}>
      <LeagueEntriesTableContextProvider league={league}>
        <MergeSourceUserBanner />
        <LeagueEntriesToolbar leagueUuid={leagueUuid} />
        <LeagueEntriesTable leagueUuid={leagueUuid} entries={entries} />
        <Outlet />
      </LeagueEntriesTableContextProvider>
    </Stack>
  );
}
